import axios from 'axios';
import Account from './main-views/Account';
import LoginView from './views/LoginView';
import ContactUs from './views/ContactUs';
import Notifications from './main-views/Notifications';
import Scan from './main-views/Scan';
import ViewOrder from './views/ViewOrder';
import Inquiries from './main-views/Inquiries';
import logo_worded_only from './assets/logo_worded_only.png';
import { STR_MENU_ACCOUNT, STR_MENU_INQUIRIES, STR_NOTIFICATIONS } from './Strings';
import LandInquirySender from './views/LandInquirySender';
import RequestedServicePaymentOptions from './views/RequestedServicePaymentOptions';
import PaymentRecordOptions from './views/PaymentRecordOptions';

export const BASE_API = 'https://kamolaapi.werenium.com/api/';
//export const BASE_API = 'http://10.196.108.207:3777/api/';

export const CDN_URL = 'https://kamola.werenium.com/cdn/';

export function getCdnUrl(fileUrl) {
  if (!fileUrl) {
    return '';
  }

  if (/^https?:\/\//i.test(fileUrl)) {
    return fileUrl;
  }

  return `${CDN_URL}${String(fileUrl).replace(/^\/+/, '')}`;
}

export function getMainView(app) {
  if (app.navItem === 'scan' || !app.navItem) {
    return <Scan />;
  } else if (app.navItem === 'notifications') {
    return <Notifications />;
  } else if (app.navItem === 'account') {
    return <Account />;
  } else if (app.navItem === 'inquiries') {
    return <Inquiries />;
  } 

  return null;
}


export function getViewerView(app) {
  if (
    app.navSubItem === 'login' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LoginView />;
  } else if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'order' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewOrder uuid={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'land-inquiry-sender' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LandInquirySender />;
  } 


  return null;
}

export function getSideViewerView(app) {
  
  if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'land-inquiry-sender' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LandInquirySender />;
  } else if (
    app.navSubItem === 'requested-service-payment-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RequestedServicePaymentOptions uuid={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'payment-record-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PaymentRecordOptions uuid={app.navExtraItem} />;
  } 
  
  return null;
}

export function getBottomViewerView(app) {

  if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } 

  return null;
}

export function getTopBarTitle(app) {
  if (app.navItem === 'account') {
    return (<span className='font-light'>{STR_MENU_ACCOUNT[app.language]}</span>);
  } else if (app.navItem === 'inquiries') {
    return (<span className='font-light'>{STR_MENU_INQUIRIES[app.language]}</span>);
  } else if (app.navItem === 'notifications') {
    return (<span className='font-light'>{STR_NOTIFICATIONS[app.language]}</span>);
  } 

  return (<img src={logo_worded_only} alt="Kamola LandLink" style={{ height: "30px", width: "auto", }} />);
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      // .. setup form data
      let formData = new FormData();
      formData.append('language', getCookie('language'));

      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((value) => formData.append(key, value));
        } else {
          formData.append(key, params[key]);
        }
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      // Retry mechanism: try up to 3 times
      let attempt = 0;
      const maxRetries = 3;

      const makeRequest = async () => {
        try {
          const response = await axios.post(BASE_API + url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          console.log(url, response.data);
          resolve(response.data); // Successfully resolve with response data
        } catch (error) {
          attempt++;
          if (attempt < maxRetries) {
            console.log(`Attempt ${attempt} failed. Retrying...`);
            makeRequest(); // Retry the request
          } else {
            resolve({
              status: 0,
              msg: "Network Connection Error after 3 attempts",
            }); // Resolve after 3 failed attempts
          }
        }
      };

      // Start the request attempts
      makeRequest();
    });
  });
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('userId');
    let userToken = getCookie('userToken');
    let userType = getCookie('userType');

    resolve({
      userId,
      userToken,
      userType,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  cname = 'kamola-user-'+cname;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();

  // Get the current domain from window.location.hostname
  let domain = window.location.hostname;

  // Set domainPart only if it's not 'localhost'
  let domainPart = domain !== 'localhost' ? `;domain=${domain}` : '';

  // Add the SameSite attribute to restrict cross-origin access (Strict or Lax as per your needs)
  let sameSite = ";SameSite=Strict";

  // Add the Secure flag for HTTPS connections
  let secureFlag = window.location.protocol === 'https:' ? ";Secure" : '';

  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + domainPart + sameSite + secureFlag;
}


export function getCookie(cname) {
  cname = 'kamola-user-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function formatMoney(x) {
  x = Number(x);

  // Check if the number has a decimal part
  let hasDecimal = x % 1 !== 0;

  // Format based on whether there's a decimal
  x = hasDecimal ? x.toFixed(2) : x.toString();

  // Split into integer and decimal parts
  var parts = x.split(".");
  
  // Add comma separation to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number, with decimals only if present
  return parts.join(".");
}

export function parseJson(value, fallback) {
  if (value && typeof value === "object") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

export async function copyText(value) {
  const text = String(value || "");

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);
    return copied;
  } catch (error) {
    return false;
  }
}
